<section class="position-relative">
  <div class="container-fluid w-limit">
    <div class="row justify-content-center text-center align-items-center">
      <div class="col-12">
        <h1 class="fs-4 text-danger mt-2">Cuéntanos un poco sobre ti</h1>
        <p class="text-body-tertiary mb-4 fs-6 fw-semibold small mx-auto" style="max-width: 400px;">
          En menos de un minuto completamos tus datos y avanzamos con tu protección.
        </p>
        <h2 class="fs-5 fw-normal">
          ¿Qué tipo de protección necesitas?
          <!-- ¿Cómo deseas tu <span class="text-primary fw-semibold">{{ getCategoryLabel(filterCategory) }}</span>? -->
        </h2>
      </div>
    </div>
  </div>
</section>
<section class="my-4">
  <div class="container-fluid">
    <div class="row justify-content-center g-2">
      <div class="col-12 col-md-8 col-lg-7 col-xl-6 col-xxl-5">
        <div class="item-check-list mx-auto gap-2 d-flex flex-column">
          @if (isLoading) {
          @for (i of [1,2,3]; track i) {
          <div class="item-check-insurance-type small bg-white shadow-sm rounded-3 d-flex align-items-center gap-3">
            <label class="item-check-body d-flex justify-content-start gap-3 py-2 px-3 align-items-center mb-0 w-100">
              <span class="check d-flex align-items-center justify-content-center position-relative py-4">
                <span class="skeleton" style="width: 24px; height: 24px; border-radius: 4px;"></span>
              </span>
              <span class="icon">
                <span class="skeleton" style="width: 36px; height: 36px; border-radius: 50%;"></span>
              </span>
              <span class="title lh-sm fs-5 fw-semibold text-start flex-grow-1">
                <span class="skeleton" style="width: 65%; height: 16px;"></span>
              </span>
              <span class="skeleton" style="width: 24px; height: 24px; border-radius: 50%;"></span>
            </label>
          </div>
          }
          } @else {
          @for (option of insuranceOptions; track option) {
          <div class="item-check-insurance-type small bg-white shadow-sm rounded-3 d-flex align-items-center gap-3"
            (click)="openOptionModal(option)">
            <label class="item-check-body d-flex justify-content-start gap-3 py-2 px-3 align-items-center mb-0 w-100">
              <span class="check d-flex align-items-center justify-content-center position-relative py-4">
                <input type="radio" class="check-input" name="insuranceType" [value]="option.id"
                  [checked]="selectedTypeIds.has(option.id!)" (click)="$event.preventDefault()"
                  (change)="$event.preventDefault()">
                <span class="check-indicator">
                </span>
                <span class="visually-hidden">Seleccionado</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="55" viewBox="0 0 21 55" fill="none">
                  <path
                    d="M19 12.8418L19 42.1582C19 51.0201 8.91296 55.9018 2 50.7646L2 4.23535C8.91296 -0.901775 19 3.97993 19 12.8418Z"
                    fill="url(#paint0_linear_652_267)" stroke="white" stroke-width="4" />
                  <defs>
                    <linearGradient id="paint0_linear_652_267" x1="21" y1="27.5" x2="1.95696e-06" y2="27.5"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="#EAEAEA" />
                      <stop offset="1" stop-color="#F6F6F6" stop-opacity="0" />
                    </linearGradient>
                  </defs>
                </svg>
              </span>
              <span class="icon">
                <app-icon [name]="getSafeIconName(option.icon || '')" [size]="36" [strokeWidth]="2.2"
                  color="#ce343c"></app-icon>
              </span>
              <span class="title lh-sm fs-5 fw-semibold text-start">
                <span class="small">
                  {{ option.name }}
                </span>
              </span>
              <button #infoButton type="button"
                class="info btn btn-sm p-1 btn-outline-light text-muted border-0 rounded-circle"
                data-bs-toggle="popover" data-bs-placement="top" data-bs-custom-class="custom-popover"
                [attr.data-info-title]="option.name" [attr.data-info-content]="option.description"
                [attr.aria-label]="'Más información sobre ' + option.name" (click)="onInfoClick($event)">
                <app-icon name="info" [size]="24" [strokeWidth]="2" color="#9e9e9e"></app-icon>
              </button>
            </label>
          </div>
          }
          }
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="requirements-info small text-muted d-flex justify-content-center gap-2 mt-3 align-items-center">
          <p class="m-0 lh-sm">** Consulta los requisitos que el asegurado debe adjuntar antes de finalizar la solicitud
          </p>
          <button #infoButton type="button" class=" btn btn-sm p-1 btn-outline-light text-muted border-0 rounded-circle"
            data-bs-toggle="popover" data-bs-placement="top" data-bs-custom-class="custom-popover"
            data-info-title="Requisitos para contratar"
            data-info-content="Ten a mano tu cédula, datos de contacto y la información de tus beneficiarios para completar la solicitud."
            aria-label="Ver requisitos del seguro" (click)="onInfoClick($event)">
            <app-icon name="info" [size]="24" [strokeWidth]="2" color="#9e9e9e"></app-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
<footer class="border-bottom border-5">
  <div class="container-fluid" style="max-width: 720px;">
    <div class="row justify-content-between g-2 border-top py-4">
      <div class="col-auto">
        <button class="btn btn-outline-secondary rounded-pill" (click)="onBack()">Retroceder</button>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary rounded-pill" (click)="onSaveAndContinue()">Guardar y continuar</button>
      </div>
    </div>
  </div>
</footer>